import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a5eaa5a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "admin-dialog"
};
const _hoisted_2 = {
  class: "box_cb"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_opsw"
}, "为0则不显示", -1));
const _hoisted_4 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { ElMessage } from "element-plus";
import { addprompt_post } from '@/service/modules/alllist';
export default /*#__PURE__*/_defineComponent({
  __name: 'prompt-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      id: "",
      name: "",
      prompt: "",
      display_order: 0,
      max_token: '',
      status: 1
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }],
      prompt: [{
        required: true,
        message: "请输入prompt",
        trigger: "blur"
      }],
      max_token: [{
        required: true,
        message: "请输入输入长度",
        trigger: "blur"
      }]
    };
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加prompt";
      } else if (props.dialogType === "edit") {
        return "编辑prompt";
      }
    });
    const emit = __emit;
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    function restForm() {
      form.id = "";
      form.name = "";
      form.prompt = "";
      form.display_order = 0;
      form.max_token = '';
      form.status = 1;
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    watch(() => props.dialogVisible, val => {
      if (val) {
        nextTick(() => {
          if (props.dialogType === "edit") {
            form.id = props.itemData.id;
            form.name = props.itemData.name;
            form.prompt = props.itemData.prompt;
            form.display_order = props.itemData.display_order;
            form.max_token = props.itemData.max_token;
            form.status = props.itemData.status;
          } else {
            restForm();
          }
        });
      }
    });
    async function submit() {
      subBtnLoading.value = true;
      let query = JSON.parse(JSON.stringify(form));
      try {
        let res = await addprompt_post(query);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        restForm();
        formRef.value?.resetFields();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "35%",
        top: "5vh",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[6] || (_cache[6] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "提示词设定",
            prop: "prompt",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 2,
                maxRows: 4
              },
              modelValue: form.prompt,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.prompt = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "排序",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.display_order,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.display_order = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "最大输入长度",
            prop: "max_token",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.max_token,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.max_token = $event),
              type: "number",
              min: "0",
              placeholder: "请输入"
            }, null, 8, ["modelValue"]), _hoisted_3]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否显示",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.status = $event),
              size: "large",
              "active-value": 1,
              "inactive-value": 2
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});